import ky from 'ky';

interface CommonResponse {
  message?: string;
  error?: string;
}

interface CodeResponse extends CommonResponse {
  code: string;
}

interface UserInfoResponse {
  enabled: boolean;
  mfa: string;
  status: string;
}

interface RequestOption {
  region?: string;
}

export class WardenApi {
  private static BASE_URL = import.meta.env.VITE_WARDEN_API_URL;

  private static instance(option: RequestOption) {
    return ky.create({
      headers: {
        'x-cupix-region': option.region,
      },
      timeout: 60000, // 60 seconds
      hooks: {
        beforeError: [
          error => {
            Promise.all([
              error.request?.text(),
              error.response?.text()
            ]).then(([requestBody, responseBody]) => {
              console.error(`req: ${requestBody}, rep: ${responseBody}`);
            });
            return error;
          }
        ],
        beforeRetry: [
          ({request, options, error, retryCount}) => {
            console.error("trying to retry request: ", {
              url: request.url,
              retryCount: retryCount,
              message: error.message
            });
          }
        ]
      }
    });
  }

  public static getUserInfo(email: string, option: RequestOption) {
    const encodedEmail = encodeURIComponent(email.toLowerCase());
    return this.instance(option).get(`${this.BASE_URL}/users?email=${encodedEmail}`).json<UserInfoResponse>();
  }

  public static updateUserPasswordUpdatedAt(email: string, option: RequestOption) {
    return this.instance(option).post(`${this.BASE_URL}/users`, {
      json: {
        email: email.toLowerCase(),
        attributes: [{
          Name: 'custom:password_updated_at',
          Value: new Date().toString(),
        }]
      },
    }).json<CommonResponse>();
  }

  public static saveToken(accessToken: string, body: unknown) {
    return ky.post(`${this.BASE_URL}/tokens/save`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
      },
      json: body,
    }).json<CodeResponse>();
  }
}
